import { NextSeo } from 'next-seo'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'

import Wishes from '@/components/pages/Wishes'
import { getWish } from '@/services/wish/api'
import { WishDataInterface } from '@/model/interfaces/wish'
import { PREFIX_URL } from '@/config/constants'

type Props = {
  data: WishDataInterface
}

const WISH_PARAMS = '?populate[1]=plant_type.icon'

const WishesPage = ({ data: wish }: Props) => {
  const title = wish?.data?.attributes?.text
  const thumbnail = `${PREFIX_URL}${wish?.data?.attributes?.plant_type?.data?.attributes?.icon?.data?.attributes?.url}`

  return (
    <>
      <NextSeo />
      {wish && (
        <Head>
          {/* <!-- Schema.org markup for Google+ --> */}
          <meta itemProp='name' content={title} />
          <meta itemProp='description' content={title} />
          <meta itemProp='image' content={thumbnail} />

          {/* <!-- Twitter Card data--> */}
          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:site' content='' />
          <meta name='twitter:title' content={title} />
          <meta name='twitter:description' content={title} />
          <meta name='twitter:creator' content='' />
          <meta name='twitter:image:src' content={thumbnail} />

          {/* <!-- Open Graph data --> */}
          <meta property='fb:app_id' content='' />
          <meta property='og:type' content='website' />
          <meta property='og:url' content='' />
          <meta name='og:title' property='og:title' content={title} />
          <meta name='og:description' property='og:description' content={title} />
          <meta property='og:image' content={thumbnail} />
        </Head>
      )}
      <Wishes wishSingle={wish?.data || null} />
    </>
  )
}

type StaticProps = {
  locale: string
  query: {
    wishId: string
  }
}

export async function getServerSideProps({ query, locale }: StaticProps) {
  if (query?.wishId) {
    try {
      return {
        props: {
          data: await getWish(query.wishId, WISH_PARAMS),
          ...(await serverSideTranslations(locale, ['common'])),
        },
      }
    } catch {
      return { notFound: true }
    }
  }

  return { props: { ...(await serverSideTranslations(locale, ['common'])) } }
}

export default WishesPage
